import { createContext } from 'react';

export type DashboardFilterContextValue = {
  range: { from: string; to: string };
  setRange: (from: string, to: string) => void;
};

export const DashboardFilterContext = createContext<DashboardFilterContextValue | null>(null);
